import React, { Component, useState, Fragment, useEffect, useMemo, useRef } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, InputLabel, Drawer, Menu, Paper } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme, getColorfont, getColor } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AccordionSummary from '@mui/material/AccordionSummary';
import SettingsIcon from '@mui/icons-material/Settings';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Popover from '@mui/material/Popover';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';

const BrandAssignToCampaign = () => {
    const history = useHistory();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);

    const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);

    const [productBrand, setProductBrand] = useState([]);
    const [enquirySource, setEnquirySource] = useState([]);
    const [selectedExecutive, setSelectedExecutive] = useState(null);
    const [executiveOptions, setExecutiveOptions] = useState([]);
    const [selectedState, setSelectedState] = useState();
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [excutiveassign, setExcutiveAssign] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [updatedData, setUpdatedData] = useState({
        status: '',

    });

    const [brands, setBrands] = useState([]);
    const [selectedBrandId, setSelectedBrandId] = useState('');
    const [selectedModelId, setSelectedModelId] = useState('');
    const [tractorModels, setTractorModels] = useState([]);
    const [doubleClickedRow, setDoubleClickedRow] = useState(null);
    const [message, setMessage] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [campaignOptions, setCampaignOptions] = useState([]);

    useEffect(() => {
        const fetchCampaignList = async () => {
            try {
                const config = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": `${token}`,
                    },
                    timeout: Infinity,
                };

                const response = await axios.post(
                    `${API_BASE_URL}/api/admin/v2/campaign-list`,
                    {},
                    config
                );

                // map unassigned_list
                const campaignData =
                    response?.data?.data?.unassigned_list?.map((item, index) => ({
                        id: index + 1,
                        title: item.campaign_id,
                    })) || [];

                setCampaignOptions(campaignData);

                console.log("Campaign List:", campaignData);
            } catch (error) {
                console.error("Error fetching campaign list:", error);
            }
        };

        fetchCampaignList();
    }, []);
    useEffect(() => {
        // Fetch brand names from the API
        fetch(`${API_BASE_URL}/mobile/api/v1/new-tractor/brand/model`)
            .then(response => response.json())
            .then(data => {
                setBrands(data.data);
            })
            .catch(error => {
                console.error('Error fetching brands:', error);
            });
    }, []);
    const handleBrandChangeBrandselect = (event) => {
        const brandId = event.target.value;
        setSelectedBrandId(brandId);

        // Fetch tractor models based on the selected brand ID
        const selectedBrand = brands.find(brand => brand.brand_id === parseInt(brandId));
        if (selectedBrand) {
            setTractorModels(selectedBrand.tractor_models);
            setSelectedModelId(''); // Reset selected model when brand changes
        }
    };
    const handleModelChange = (event) => {
        const modelId = event.target.value;
        setSelectedModelId(modelId);
    };

    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity, // Request will never time out
                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);

                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));

                setBrandOptions(statelist);

            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };

        fetchDatabrand();
    }, []);

    useEffect(() => {
        const fetchDatastate = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,

                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.state_name,
                    title: item.state_name,
                }));

                setStateOptions(statelist);

            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };

        fetchDatastate();
    }, []);

    useEffect(() => {
        const fetchDatalist = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);

                const filteredData = response.data.data.filter(item => item.status === 1);

                const mappedData = filteredData.map(item => ({
                    id: item.admin_id,
                    title: item.username,
                }));
                const optionsWithNull = [
                    // { id: null, title: 'Select Executive' },
                    ...mappedData,
                ];

                setExecutiveOptions(optionsWithNull);

            } catch (error) {
                console.error('Error fetching executives:', error);
            }
        };

        fetchDatalist();
    }, []);




    const handleExecutiveChange = (event) => {
        const selectedId = event.target.value;
        setSelectedExecutive(selectedId);
    };
    const handleStateChange = (event, newValue) => {
        setSelectedState(newValue);
    };

    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };

    const fetchData = async () => {
        setError(null);
        setIsLoading(true);

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };

            const requestData = {
                brand_id: selectedBrand?.id || "",
                is_active: false,
                pagination: perPage,
                page: page + 1,
            };

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/assign-campagin-brand-list`,
                requestData,
                config
            );

            const mappedData =
                response?.data?.data?.data?.map((item, index) => ({
                    id: (page * perPage) + index + 1,
                    "Campaign ID": item.campaign_id || "",
                    "Brand Name": item.brand_name || item.brand?.brand_name || "",
                    "Status": item.is_active ? "Active" : "Inactive",
                    created_at: new Date(item.created_at).toLocaleString("en-IN", {
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                    }),
                })) || [];

            setData(mappedData);
            setTotalCount(response?.data?.data?.total || 0);

            setSnackbarMessage(response.data.message);
            setSnackbarOpen(true);

        } catch (error) {
            console.error("Error fetching data:", error);

            setError(
                error?.response?.data?.message ||
                "An error occurred while fetching data."
            );
        } finally {
            setIsLoading(false);
        }
    };

    const source = axios.CancelToken.source();
    const sourceRef = useRef(null);

    useEffect(() => {
        sourceRef.current = axios.CancelToken.source();
        fetchData(
            perPage,
            page,
            search,
            totalCount,
            selectedExecutive,
            selectedBrand,
            selectedState,
            enquirySource,
            sourceRef.current
        );
        return () => {
            sourceRef.current.cancel('Request canceled by cleanup');
        };
    }, [perPage, page,], 2000);

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };

    const handlePerPageChange = (e) => {
        setPerPage(Number(e.target.value));
    };

    const handlePrevious = () => {
        if (page > 0) {
            setPage(page - 1);
        }
    };

    const handleNext = () => {
        setPage(page + 1);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        setSelectedRows([]);
        fetchData(perPage, page, search, totalCount, selectedExecutive, selectedBrand, selectedState, enquirySource);
    };

    const clearForm = () => {
        window.location.reload();
        setSearch('');

    };


    const handleSelectAllCheck = () => {
        if (selectedRows.length === data.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(Array.from({ length: data.length }, (_, i) => i));
        }
    };

    const handleRowSelect = (rowIndex) => {
        if (selectedRows.includes(rowIndex)) {
            setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
        } else {
            setSelectedRows([...selectedRows, rowIndex]);
        }
    };

    const handleRowsSelect = (currentRowsSelected, allRowsSelected) => {
        setSelectedRows(allRowsSelected.map((row) => row.index));
    };

    const handleRowsDelete = (rowsDeleted) => {
        console.log('Rows to be deleted:', rowsDeleted);
    };

    const handleSubmits = async () => {
        if (!excutiveassign) {
            setSnackbarMessage("Please select Campaign ID");
            setSnackbarOpen(true);
            return;
        }

        if (!selectedBrand?.id) {
            setSnackbarMessage("Please select Brand");
            setSnackbarOpen(true);
            return;
        }

        setIsLoading(true);

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };

            const payload = {
                campaign_id: excutiveassign,
                brand_id: selectedBrand.id,
            };

            console.log("Payload:", payload);

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/assign-campagin-brand`,
                payload,
                config
            );

            console.log("API Response:", response.data);

            setMessage(response.data.message);
            setSnackbarMessage(response.data.message);
            setSnackbarOpen(true);

            // reset fields after success
            setExcutiveAssign("");
            setSelectedBrand(null);

            // refresh table if needed
            fetchData();

        } catch (error) {
            console.error("API Error:", error);

            setSnackbarMessage(
                error?.response?.data?.message || "Something went wrong"
            );
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };
    const handleExecutiveChanges = (e) => {
        setExcutiveAssign(e.target.value);
    };
    const columns = [

        {
            name: 'id',
            label: (
                <input
                    type="checkbox"
                    checked={selectedRows.length === data.length && data.length !== 0}
                    onChange={handleSelectAllCheck}
                />
            ),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => (
                    <input
                        type="checkbox"
                        checked={selectedRows.includes(tableMeta.rowIndex)}
                        onChange={() => handleRowSelect(tableMeta.rowIndex)}
                    />
                ),
            },
        },
        {
            name: 'id', options: {
                filter: true,
                setCellProps: () => ({
                    align: "left",
                })
            },
            label: "S/N",
        },

        {
            name: "Campaign ID",
            label: "Campaign ID",
        },
        {
            name: "Brand Name",
            label: "Brand Name",
            options: {
                filter: true,
                setCellProps: () => ({
                    align: "left",
                })
            },
        },
        {
            name: "Status",
            label: "Status",
            options: {
                filter: true,
                setCellProps: () => ({
                    align: "left",
                })
            },
        },
        {
            name: "created_at",
            label: "Date",
        },
    ]
    const CustomToolbarAction = ({ toggleFilter }) => (
        <IconButton aria-label="Filter list" onClick={toggleFilter}>
            <FilterListIcon onClick={toggleSidebar} />
        </IconButton>
    );


    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    const handleRowClick = (rowIndex) => {
        const isSelected = selectedRows.includes(rowIndex);
        if (isSelected) {
            setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
        } else {
            setSelectedRows([...selectedRows, rowIndex]);
        }
    };

    const options = {
        onRowClick: (rowData, rowMeta) => handleRowClick(rowMeta.dataIndex),
        selectableRows: 'multiple',
        onRowsSelect: handleRowsSelect,
        onRowsDelete: handleRowsDelete,
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },

        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
        customFilterDialogFooter: (currentFilter, applyNewFilter) => (
            <div>
                <TextField
                    label="Filter Data"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    fullWidth
                />
                <Button onClick={applyNewFilter} variant="contained" color="primary">
                    Apply Filter
                </Button>
                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
                    Cancel
                </Button>
            </div>
        ),
        setRowProps: (row, dataIndex, rowIndex) => ({
            style: {
                backgroundColor: doubleClickedRow === rowIndex ? '#D2DE32' : selectedRows.includes(dataIndex) ? '#D2DE32' : 'inherit',
            },
            onDoubleClick: () => handleRowDoubleClick(row, rowIndex),
        }),

    };
    const currentTheme = customTheme(true);
    const classes = useStyles();
    const memoizedData = useMemo(() => data, [data]);
    const handleRowDoubleClick = (row, rowIndex) => {
        console.log("Row double-clicked:", row);
        console.log("Row index:", rowIndex);
        const updatedSelectedRows = [...selectedRows];
        const rowIndexInSelectedRows = updatedSelectedRows.indexOf(rowIndex);
        if (rowIndexInSelectedRows === -1) {
            updatedSelectedRows.push(rowIndex);
        } else {
            updatedSelectedRows.splice(rowIndexInSelectedRows, 1);
        }
        setSelectedRows(updatedSelectedRows);
    };

    const handleUpdateClick = (event, rowIndex) => {
        setSelectedUser(data[rowIndex]);
        setUpdatedData({
            status: data[rowIndex].status,
            email: data[rowIndex].email,

        });
        setPopoverAnchor(event.currentTarget);
    };
    const handleClosePopover = () => {
        setPopoverAnchor(null);
    };

    const handleInputChange = (e) => {
        setUpdatedData({
            ...updatedData,
            [e.target.name]: e.target.value,
        });

        if (e.target.name === 'status') {
            handleFormSubmit();
        }
    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            const updatedUserData = { ...selectedUser, ...updatedData };

            const response = await axios.post(`${API_BASE_URL}/api/admin/v2/bulk-status-change/${selectedUser.id}`, updatedUserData);
            console.log('User data updated:', updatedUserData);
            setMessage(response.data.message);
            handleClosePopover();
        } catch (error) {
            console.error('Error updating user data:', error);
        }
    };
    const statusOptions = ['Status', 'Busy', 'Not Connected', 'Switched Off', 'Wrong Number'];
    const handleSelectedRowsCount = () => {
        return selectedRows.length;
    };
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };
    return (
        <>
            {message && <p
                className={classes.message}
            >{message}</p>}
            <div>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </MuiAlert>
                </Snackbar>
            </div>

            <Box sx={{ width: '100%' }}>

                <Grid container>
                    <Grid item xs={6} style={{ marginTop: "8px" }}>
                        <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                            Brand Assign To Campaign
                        </Typography>
                    </Grid>

                </Grid>
                <hr className={classes.horizontalline} />

            </Box>
            <div className={classes.root}>
                <div className={classes.root}  >
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={3} lg={3}>
                            <select
                                style={{ marginRight: "10px" }}
                                className={classes.selectform}
                                value={excutiveassign}
                                onChange={handleExecutiveChanges}
                            >
                                <option value="">Campaign ID</option>

                                {campaignOptions.map((option) => (
                                    <option key={option.id} value={option.title}>
                                        {option.title}
                                    </option>
                                ))}
                            </select>
                        </Grid>
                        <Grid item xs={4} sm={3} lg={3} >
                            <Autocomplete
                                classes={{
                                    option: classes.autocompleteoption,
                                }}
                                options={brandOptions}
                                getOptionLabel={(option) => option.title}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder='Select brand' variant="outlined" />
                                )}
                                value={selectedBrand}
                                onChange={handleBrandChange}
                                disableCloseOnSelect
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionSelected={(option, value) => option.id === value.id}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>

                                        {option.title}
                                    </li>
                                )}
                            />
                        </Grid>

                        <Grid item xs={4} sm={3} lg={3} >
                            <Button
                                onClick={handleSubmits}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined"
                                startIcon={<AssignmentIndIcon />}
                            >
                                Brand Assign To Campaign
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <br />
            <MuiThemeProvider theme={customTheme()}>
                {
                    isLoading ? (
                        <LinearProgress />

                    ) : (
                        ""
                    )
                }
                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />

                        ) : (
                            <Typography className={classes.tabletittle} >
                                Brand Assign To Campaign
                            </Typography>
                        )
                    } data={memoizedData}
                    columns={columns}
                    options={options}
                />

            </MuiThemeProvider>
            <Drawer anchor="right" open={openSidebar}

                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}

                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>

                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>

                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} lg={12} >

                                    <select
                                        className={classes.inputform}
                                        value={selectedExecutive}
                                        onChange={handleExecutiveChange}
                                    >
                                        <option value="">Campaign ID</option>

                                        {campaignOptions.map((option) => (
                                            <option key={option.id} value={option.title}>
                                                {option.title}
                                            </option>
                                        ))}
                                    </select>



                                </Grid>

                                <Grid item xs={12} sm={12} lg={12} >
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={brandOptions}
                                        getOptionLabel={(option) => option.title}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder='Select Brand' variant="outlined" />
                                        )}
                                        value={selectedBrand}
                                        onChange={handleBrandChange}
                                        disableCloseOnSelect
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                {option.title}
                                            </li>
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={4} sm={2} lg={12} >
                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />

                                </Grid>

                                <Grid item xs={4} sm={2} lg={12}>
                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >
                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>

                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >

            <Popover
                open={Boolean(popoverAnchor)}
                anchorEl={popoverAnchor}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {selectedUser && (
                    <div>
                        <form onSubmit={handleFormSubmit}>

                            <div style={{ display: "flex", padding: "10px" }}>
                                <label>
                                    <select
                                        style={{ width: "100px", marginRight: "10px" }}
                                        className={classes.selectform}
                                        name="status"
                                        value={updatedData.status}
                                        onChange={handleInputChange}
                                    >
                                        {statusOptions.map((status) => (
                                            <option key={status} value={status}>
                                                {status}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                                <Button
                                    style={{ marginRight: "10px" }}
                                    className={classes.buttonform}
                                    type="submit">Submit</Button>
                            </div>


                        </form>
                    </div>
                )}
            </Popover>

        </>
    );
};

export default BrandAssignToCampaign;


